import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/app/routes';
import { LoadingOverlay } from '@/components/feedback';
import { useTranslations } from '@/hooks';
import {
  OutgoingShipmentForm,
  EMPTY_OUTGOING_SHIPMENT_FORM,
} from '../components/OutgoingShipmentForm';
import { useCreateOutgoingShipmentMutation } from '../api/outgoingShipmentsApi';
import { useOutgoingShipmentFormOptions } from '../hooks';

// Outbounds ▸ Outgoing shipments ▸ Add.
export const AddOutgoingShipmentPage = () => {
  const t = useTranslations();
  const navigate = useNavigate();
  const { module } = useParams();

  const [createOutgoingShipment, { isLoading: isSubmitting }] = useCreateOutgoingShipmentMutation();

  const { options, isLoading } = useOutgoingShipmentFormOptions();

  const goToShipments = useCallback(() => {
    navigate(ROUTES.outgoingShipments(module));
  }, [navigate, module]);

  const handleSubmit = useCallback(
    async (values) => {
      try {
        await createOutgoingShipment({ module, values }).unwrap();
        goToShipments();
      } catch {
        // notifyApiErrors already surfaced it.
      }
    },
    [createOutgoingShipment, module, goToShipments],
  );

  // Wait for the dropdowns: <Form> seeds initialValues once, on mount.
  if (isLoading) {
    return <LoadingOverlay label={t('COMMON_LOADING')} />;
  }

  return (
    <OutgoingShipmentForm
      title={t('OUTGOING_SHIPMENTS_ADD')}
      submitLabel={t('COMMON_SAVE')}
      initialValues={EMPTY_OUTGOING_SHIPMENT_FORM}
      onSubmit={handleSubmit}
      onClose={goToShipments}
      isSubmitting={isSubmitting}
      options={options}
    />
  );
};
